
import React from 'react';
import SimpleConverter from './SimpleConverter';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

const DigitalStorageConverter = () => {
  // This is a placeholder for the coming soon feature
  return (
    <div className="space-y-4">
      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          Digital Storage Converter is coming soon! Check back later for this feature.
        </AlertDescription>
      </Alert>
      
      <div className="bg-muted/50 p-10 rounded-lg flex items-center justify-center">
        <h3 className="text-xl text-muted-foreground">Coming Soon</h3>
      </div>
    </div>
  );
};

export default DigitalStorageConverter;
